import endpoints from './endpoints';

const host = 'https://www.posillicomaterials.com';
const api = 'https://posillico-cms-prod-5e570cebba67.herokuapp.com';

export default {
	host,
	api,

	bucket: 'https://posillicocmsstorage.blob.core.windows.net/production',

	endpoints: endpoints(api),

	externalUrl: {
		posillico: '//posillicoinc.com',
		materials: '//posillicomaterials.com',
	},
};
